<template>
  <v-row dense no-gutters :justify="actionJustify">
    <v-btn :class="btnClass" @click="dialog=true" text color="primary" :ripple="false"><v-icon left>mdi-plus</v-icon>Agregar complemento</v-btn>

    <!-- addon dialog -->
    <v-dialog v-model="dialog" width="600" persistent scrollable no-click-animation>
      <v-card class="pa-0">
        <v-card-title class="pa-0">
          <v-toolbar color="transparent" flat height="55">
            <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Seleccionar un complemento</v-toolbar-title>
            <v-spacer/>
            <v-toolbar-items>
              <v-row align="center" justify="center" class="pr-1">
                <v-btn class="ml-3" @click="dialog=false" icon small><v-icon size="24">mdi-close</v-icon></v-btn>
              </v-row>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-0 background">
          <v-row align="center" justify="center" no-gutters>
            <v-col cols="12" class="text-left">
              <v-col class="pt-2 pb-1">
                <v-text-field v-model="addonQuery" background-color="white" outlined required single-line dense  placeholder="Escribe para buscar un complemento..." hide-details/>
              </v-col>
              <v-col v-if="currency" class="pa-0">
                <v-divider/>
                <p class="my-2 pl-3">Sólo se muestran complemento en moneda <b> {{currency.id}}</b></p>
              </v-col>
              <v-divider/>
              <v-skeleton-loader v-if="$store.state.subscriptions.retrieveLoader" transition="fade-transition" type="list-item"/>
              <template v-else>
                <template v-if="addonsList.length">
                  <v-simple-table>
                    <template v-slot:default>
                      <tbody>
                        <tr v-for="d in addonsList" :key="d.id" @click="set(d)" :style="checkIsAdded(d.id) ? '' : 'cursor: pointer'">
                          <td class="py-3">
                            <div class="d-flex">
                              <span class="body-1 text--secondary font-weight-medium">{{d.name}}</span>
                              <template v-if="checkIsAdded(d.id)">
                                <v-spacer/>
                                <v-chip color="defaultGrey" text-color="secondary" small>Añadido<v-icon class="ml-1" x-small>mdi-check</v-icon></v-chip>
                              </template>
                            </div>
                            <span class="mr-1">{{d.amount | number(d.currency.rounded)}} {{d.currency.id}} / {{d.apply_scheme === 'recurring' ? 'Recurrente' : 'Una vez'}}</span>
                            <span class="mx-1" v-if="d.apply_scheme === 'recurring'">válido por {{d.duration_times}} ciclos de facturación</span>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </template>
                <v-col class="text-center py-8" v-else>
                  <div class="text-center mb-4">
                    <v-icon size="70" color="#6B7C93">mdi-times-circle</v-icon>
                  </div>
                  <span class="subtitle-1 text-center font-weight-regular">No existen complementos</span>
                </v-col>
              </template>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end products dialog -->
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import GenericViewMixin from '@/mixins/GenericViewMixin'
export default {
  props: {
    actionJustify: {
      type: String,
      required: false,
      default: () => ('start')
    },
    btnClass: {
      type: String,
      required: false,
      default: () => ('')
    },
    currency: {
      type: Object,
      required: false,
      default () {
        return null
      }
    },
    selectedItems: {
      type: Array,
      required: false,
      default () {
        return []
      }
    },
    extraQuery: {
      type: Object,
      required: false,
      default () {
        return {}
      }
    }
  },
  mixins: [
    GenericViewMixin
  ],
  data: () => ({
    addonQuery: '',
    selected: {},
    dialog: false
  }),
  computed: mapState({
    addonsList: state => state.subscriptions.addonsList
  }),
  watch: {
    addonQuery () {
      this.debounceMethod(this.listAddons)
    },
    dialog () {
      if (this.dialog) {
        this.listAddons()
      }
    }
  },
  methods: {
    listAddons () {
      if ([1, 2].includes(this.addonQuery.length)) {
        return false
      }
      const query = {
        page_size: 10
      }
      if (this.addonQuery.length >= 3) {
        query.name__icontains = this.addonQuery.toLowerCase()
      }
      if (this.currency) {
        query.currency = this.currency.id
      }
      this.$store.dispatch('subscriptions/LIST', {
        resource: 'addons',
        query: Object.assign({}, query, this.extraQuery)
      })
    },
    set (addon) {
      if (this.checkIsAdded(addon.id)) {
        return false
      }
      this.addonQuery = ''
      this.selected = {}
      this.dialog = false
      this.$emit('selected', addon)
    },
    checkIsAdded (id) {
      if (this.selectedItems.filter(i => i === id).length) {
        return true
      }
      return false
    }
  }
}
</script>